<template>
    <TableLayout :permissions="['system:user:query']">
      <!-- 搜索表单 -->
      <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="80px" inline>
        <el-form-item label="账号信息" prop="keyword">
          <el-input v-model="searchForm.keyword" v-trim placeholder="请输入登录账号/姓名" @keypress.enter.native="search"/>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="searchForm.status" clearable placeholder="请选择">
            <el-option
              v-for="item in status"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <section>
          <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          <el-button @click="reset">重置</el-button>
        </section>
      </el-form>
      <!-- 表格和分页 -->
      <template v-slot:table-wrap>
        <ul class="toolbar" v-permissions="['system:user:create', 'system:user:delete']">
          <li v-permissions="['system:user:create']"><el-button icon="el-icon-plus" type="primary" @click="$refs.OperaAnchorWindow.open('新建用户')">新建</el-button></li>
          <!-- <li v-permissions="['system:user:delete']"><el-button icon="el-icon-delete" @click="deleteByIdInBatch">删除</el-button></li> -->
        </ul>
        <el-table
          v-loading="isWorking.search"
          :data="tableData.list"
          :default-sort = "{prop: 'createTime', order: 'descending'}"
          stripe
          @selection-change="handleSelectionChange"
          @sort-change="handleSortChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="username" label="登录账号"></el-table-column>
          <el-table-column prop="realname" label="姓名"></el-table-column>
          <el-table-column prop="mobile" label="手机号"></el-table-column>
          <el-table-column label="主播端地址">
            <template slot-scope="{row}">
              <el-link type="primary" @click="openLink(row.zhuboRoomUrl)">点击访问</el-link>
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="{row}">
              <el-switch
                v-model="row.status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                @change="changeStatus($event, row.id)"
                :active-value="0"
                :inactive-value="1">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
          <el-table-column
            v-if="containPermissions(['system:user:update', 'system:user:createUserRole', 'system:user:resetPwd', 'system:user:delete'])"
            label="操作"
            width="230"
            fixed="right"
          >
            <template slot-scope="{row}">
              <el-button type="text" icon="el-icon-edit" @click="edit(row)" v-permissions="['system:user:update']">编辑</el-button>
              <el-button type="text" @click="editPass(row)" v-permissions="['system:user:resetPwd']">修改密码</el-button>
              <el-button type="text" icon="el-icon-delete" @click="deleteById(row)" v-permissions="['system:user:delete']">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <pagination
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
          :pagination="tableData.pagination"
        ></pagination>
      </template>
      <!-- 新建/修改 -->
      <OperaAnchorWindow ref="OperaAnchorWindow" @success="handlePageChange"/>
      <!-- 修改密码 -->
      <OperaAnchorPassWindow ref="OperaAnchorPassWindow" @success="handlePageChange"/>
    </TableLayout>
  </template>
  
  <script>
  import Pagination from '@/components/common/Pagination'
  import TableLayout from '@/layouts/TableLayout'
  import BaseTable from '@/components/base/BaseTable'
  import OperaAnchorWindow from '@/components/business/OperaAnchorWindow'
  import OperaAnchorPassWindow from '@/components/business/OperaAnchorPassWindow'
  import { updUserStatus } from '@/api/business/anchor.js'
  
  export default {
    name: 'SystemUser',
    extends: BaseTable,
    components: { OperaAnchorWindow, TableLayout, Pagination, OperaAnchorPassWindow },
    data () {
      return {
        // 搜索
        searchForm: {
          status: '',
          keyword: '',
          type: 2
        },
        status: [
          { name: '启用', id: 0 },
          { name: '禁用', id: 1 }
        ]
      }
    },
    created () {
      this.config({
        module: '用户',
        api: '/business/anchor',
        'field.main': 'realname',
        sorts: [{
          property: 'CREATE_TIME',
          direction: 'DESC'
        }]
      })
      this.search()
    },
    methods: {
      openLink(link) {
        window.open(link)
      },
      editPass(row) {
        let obj = {
          id: row.id
        }
        this.$refs.OperaAnchorPassWindow.open('修改密码', obj)
      },
      // 修改状态
      changeStatus(status, id) {
        updUserStatus({ id, status })
          .then(res => {
            console.log(res)
          })
      },
      edit(row) {
        let obj = {
          id: row.id,
          userName: row.username,
          password: row.password,
          realName: row.realname,
          mobile: row.mobile
        }
        this.$refs.OperaAnchorWindow.open('编辑用户', obj)
      }
    }
  }
  </script>
  
  <style scoped lang="scss">
  @import "@/assets/style/variables.scss";
  // 列表头像处理
  .table-column-avatar {
    img {
      width: 48px;
    }
  }
  </style>
  